
import Vue from 'vue';
import { emitter } from '@/utils/constants';
import { SnackbarMessage } from '@/models/events';

export default Vue.extend({
  data: () => ({
    snackbar: false,
    snackbarText: '',
    snackbarColor: '',
  }),

  created() {
    emitter.on('notify', (e) => this.openSnackbar(e as SnackbarMessage));
  },

  methods: {
    openSnackbar(options: SnackbarMessage) {
      this.snackbar = true;
      this.snackbarText = options.text || '';
      this.snackbarColor = options.color || '';
    },
  },
});
